'use client';
/* eslint-disable @typescript-eslint/naming-convention */

import { FC, useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import { getSanitizedInnerHTML } from '@core/Utils/Html/SanitizeHtml';
import Button from '@gds/Button/Button';

import styles from './RichText.module.css';

type Props = {
  richText: string;
  noPadding?: boolean;
  className?: string;
  ctaText: string;
  threshold: number;
};

export const RichTextWithViewMoreCta: FC<Props> = ({
  noPadding,
  richText,
  className,
  ctaText,
  threshold,
}) => {
  const [isOverflown, setIsOverflown] = useState(false);
  const richTextRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const richTextElement = richTextRef.current;
    if (richTextElement) {
      const { clientHeight } = richTextElement;

      // Check if the rich text goes beyond the threshold
      if (clientHeight > threshold) {
        setIsOverflown(true);
      } else {
        setIsOverflown(false);
      }
    }
  }, []);

  const classNames = cn(
    styles.richTextCtaContainer,
    styles.richText,
    noPadding && styles.noPadding,
    className,
  );
  const sanitizedRichText = getSanitizedInnerHTML(richText);

  const handleViewMore = () => {
    setIsOverflown(false);
  };

  return (
    <div ref={richTextRef} className={classNames}>
      <div
        dangerouslySetInnerHTML={sanitizedRichText}
        className={isOverflown ? styles.overflownText : ''}
      />

      {isOverflown && (
        <Button variant="link" className={styles.viewMore} onClick={handleViewMore}>
          {ctaText}
        </Button>
      )}
    </div>
  );
};
